export default __webpack_public_path__ + "static/media/classic1.53e10fdb.jpg";